import { FormikProps } from 'formik';
import { ReactNode, RefObject } from 'react';
import { connect } from 'react-redux';
import { selectFormInitialResourceFromTable } from 'redux/form/selectors';
import { IRootState } from 'redux/reducer';
import { IDrawerWidth } from 'utils/configs/drawerWidths';
import { IObatResourceClass } from 'utils/strings/resourceClasses';
import * as yup from 'yup';

import { ObatResourceFormDrawer as Component } from './ObatResourceFormDrawer.component';

interface IOwnProps<IResourceFormValues, IResourceRequestParams> {
  formFocusRef: RefObject<HTMLInputElement>;
  renderForm: (formikProps: FormikProps<IResourceFormValues>) => ReactNode;
  getInitialFormValues: () => IResourceFormValues;
  getRequestParams?: (finalFormValues: IResourceFormValues) => IResourceRequestParams;
  getValidationSchema: () => yup.ObjectSchema /*<IResourceFormValues>*/;
  renderSubForm?: () => ReactNode;
  formDrawerWidth: IDrawerWidth;
  resourceClass: IObatResourceClass;
  subFormResources?: IObatResourceClass[];
  forceSubmitDisabled?: (formikProps: FormikProps<IResourceFormValues>) => boolean;
  title?: string;
  isCopy?: boolean;
}

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = typeof mapDispatchToProps;

export type IInjectedProps = IStateProps & IDispatchProps;

export type IProps<IResourceFormValues, IResourceRequestParams> = IOwnProps<
  IResourceFormValues,
  IResourceRequestParams
> &
  IInjectedProps;

const mapStateToProps = <IResourceFormValues, IResourceRequestParams>(
  rootState: IRootState,
  ownProps: IOwnProps<IResourceFormValues, IResourceRequestParams>
) => {
  return { initialObatResource: selectFormInitialResourceFromTable(ownProps.resourceClass)(rootState) };
};

const mapDispatchToProps = {};

export const getObatResourceFormDrawer = <IResourceFormValues, IResourceRequestParams>() => {
  return connect<IStateProps, IDispatchProps, IOwnProps<IResourceFormValues, IResourceRequestParams>, IRootState>(
    mapStateToProps,
    mapDispatchToProps
  )(Component as new () => Component<IResourceFormValues, IResourceRequestParams>);
};
